(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-video-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tb-video-carousel')) customElements.define('tb-video-carousel',class extends HTMLElement{
  connectedCallback(){
    this.track=this.querySelector('.tb-videos__track');this.cards=Array.from(this.querySelectorAll('.tb-videos__card'));if(!this.cards.length)return;
    this.prev=this.querySelector('.tb-videos__arrow--prev');this.next=this.querySelector('.tb-videos__arrow--next');
    this.abort=new AbortController();const opts={signal:this.abort.signal};
    this.prev.addEventListener('click',()=>this.go(this.index-1),opts);this.next.addEventListener('click',()=>this.go(this.index+1),opts);
    this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update())},{...opts,passive:true});
    this.cards.forEach((card,index)=>{const video=card.querySelector('video'),play=card.querySelector('.tb-videos__play');if(!video)return;
      video.muted=true;video.loop=true;
      card.addEventListener('click',e=>{if(index!==this.index){e.preventDefault();this.go(index)}}, {...opts,capture:true});
      play.addEventListener('click',()=>{this.go(index);this.cards.forEach(c=>{const v=c.querySelector('video');if(v&&v!==video)v.pause()});video.play().catch(()=>card.classList.remove('is-playing'))},opts);
      video.addEventListener('play',()=>card.classList.add('is-playing'),opts);video.addEventListener('pause',()=>card.classList.remove('is-playing'),opts);video.addEventListener('ended',()=>card.classList.remove('is-playing'),opts);
    });
    this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);
    this.visibility=()=>this.syncPlayback();document.addEventListener('visibilitychange',this.visibility,opts);
    this.inView=false;this.intersection=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.syncPlayback()},{threshold:.2});this.intersection.observe(this);
    this.editorSelect=e=>{const index=this.cards.findIndex(c=>c.contains(e.target));if(index>=0)this.go(index)};this.addEventListener('shopify:block:select',this.editorSelect,opts);
    this.go(Math.floor(this.cards.length/2),true);
  }
  go(index,instant=false){index=(index+this.cards.length)%this.cards.length;const card=this.cards[index];this.track.scrollTo({left:card.offsetLeft-this.track.offsetLeft-(this.track.clientWidth-card.clientWidth)/2,behavior:instant||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.update()}
  update(){const previous=this.index;const rect=this.track.getBoundingClientRect(),center=rect.left+rect.width/2;let best=Infinity;this.index=0;this.cards.forEach((c,i)=>{const r=c.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<best){best=d;this.index=i}});this.cards.forEach((c,i)=>{c.classList.toggle('is-active',i===this.index);c.classList.toggle('is-near',Math.abs(i-this.index)===1)});this.prev.disabled=this.next.disabled=this.cards.length<2;if(previous!==this.index)this.syncPlayback()}
  syncPlayback(){this.cards.forEach((c,i)=>{const video=c.querySelector('video');if(!video)return;if(i===this.index&&this.inView&&!document.hidden){video.play().catch(()=>c.classList.remove('is-playing'))}else video.pause()})}
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.intersection?.disconnect();cancelAnimationFrame(this.frame);this.cards?.forEach(c=>c.querySelector('video')?.pause())}
});

  } catch(e) { console.error(e); }
})();
})();
